export const CONTEXT_DEFAULT = 'CONTEXT_DEFAULT'
export const CONTEXT_QUICK = 'CONTEXT_QUICK'
export const CONTEXT_IOS = 'CONTEXT_IOS'
